import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { deleteChain } from '../index';
export const useDeleteChain = (callback) => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(deleteChain, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetIntegrationChainDescriptionList');
            setAction({
                type: 'success',
                message: 'Removing the integration chain was successful',
            });
            if (callback && typeof callback === 'function') {
                callback();
            }
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
